var CompanyReallocateValidation = /** @class */ (function () {
    function CompanyReallocateValidation() {
    }
    CompanyReallocateValidation.validate = function (formGroup) {
        var company = formGroup.controls.company.value;
        var newCompany = formGroup.controls.newCompany.value;
        if (!company || !newCompany) {
            return null;
        }
        if (company.id === newCompany.id) {
            return formGroup.controls.newCompany.setErrors({
                companyReallocateDuplicated: true
            });
        }
        return null;
    };
    return CompanyReallocateValidation;
}());
export { CompanyReallocateValidation };
